import Clients from './views/public/Clients.svelte'
import Mileage from './views/public/Mileage.svelte'
import Transactions from './views/public/Transactions.svelte'
import Time from './views/public/Times.svelte'
import Reports from './views/public/Reports.svelte'
import Metrics from './views/public/Metrics.svelte'

const routes = [
  {
    name: '/',
    component: Clients,
  },
  {
    name: '/clients',
    component: Clients,
  },
  {
    name: '/mileage',
    component: Mileage,
  },
  {
    name: '/mileage/post',
    component: Mileage,
  },
  {
    name: '/transactions',
    component: Transactions,
  },
  {
    name: '/time',
    component: Time,
  },
  {
    name: '/reports',
    component: Reports,
  },
  {
    name: '/metrics',
    component: Metrics,
  }
]

export { routes }
